import { observable } from 'mobx'
import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'

class UploadMyFileStore {
  @observable isLoading = false

  create = async fileParam => {
    this.isLoading = true
    await ResourcesRequest.create(fileParam)
    this.isLoading = false
    ResourcesStore.search()
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new UploadMyFileStore()

